import AutoTextArea from '@op/components/AutoTextArea';
import classNames from 'classnames';
import React from 'react';
import { Icon, TextAreaProps } from 'tea-component';

interface IAutoTextAreaBoxProps extends TextAreaProps {
  value: string;
  setValue: (value: string) => void;
  grammarTrue?: boolean;
  grammarText?: string;
  placeholder?: any;
  minHeight?: number;
  replaceText?: { text: string; value: string }[];
  hasTips?: boolean;
}

export default function AutoTextAreaBox({
  value,
  setValue,
  grammarTrue,
  grammarText,
  placeholder,
  minHeight = 82,
  replaceText = [],
  hasTips = true,
  ...props
}: IAutoTextAreaBoxProps) {
  return (
    <>
      <AutoTextArea
        value={value}
        onChange={(value) => {
          let info = value;
          replaceText.forEach((item) => {
            info = info.replaceAll(item.text, item.value);
          });
          setValue(info);
        }}
        placeholder={placeholder}
        style={{ minHeight, width: '100%' }}
        {...props}
      ></AutoTextArea>
      {value && hasTips && (
        <div
          className={classNames('dbo-form-fill-status', {
            '--correct': grammarTrue,
            '--error': !grammarTrue,
          })}
        >
          <Icon
            type={`${grammarTrue ? 'success' : 'error'}`}
            style={{ marginRight: '6px' }}
          />
          <span>{grammarText}</span>
        </div>
      )}
    </>
  );
}
